/// <reference types="@angular/localize" />

import { enableProdMode, mergeApplicationConfig } from '@angular/core';

import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { getApp } from '@angular/fire/app';
import {
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  initializeAuth,
  provideAuth
} from '@angular/fire/auth';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import {
  getRemoteConfig,
  provideRemoteConfig
} from '@angular/fire/remote-config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { RecaptchaBrowserService } from './app/recaptcha-browser.service';

if (environment.production) {
  enableProdMode();
}
declare global {
  interface Window {
    FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  bootstrapApplication(
    AppComponent,
    mergeApplicationConfig(appConfig, {
      providers: [
        provideRemoteConfig(() => getRemoteConfig()),
        provideAnalytics(() => getAnalytics()),
        provideMessaging(() => getMessaging()),
        provideAuth(() => {
          return initializeAuth(getApp(), {
            persistence: indexedDBLocalPersistence,
            popupRedirectResolver: browserPopupRedirectResolver
          });
        }),
        provideAppCheck((injector) => initializeAppCheck(getApp(), {
          provider: injector.get(RecaptchaBrowserService).provider(environment.firebase.appCheckKey),
          isTokenAutoRefreshEnabled: true
        })
      ),
      ]
    })
  ).catch((err) => console.error(err));
});
